'use strict';

angular.module('TurneroApp').service('TRSService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/TRS/:id', { id: '@Id_Tasa' }, {
    	Get_Tasas_Turno: {
            method: 'GET',
            params:{
            	id_turno: '@id_turno',
               // Id_Tramite_Relevado : '@Id_Tramite_Relevado'
            },
            url: portal.getUrlServer() + 'api/TRS/Get_Tasas_Turno/'
    	},
    	Get_Tasas_Tramite: {
    		method: 'GET',
    		params: {
    			 id_tramite_relevado : '@Id_Tramite_Relevado'
    		},
    		url: portal.getUrlServer() + 'api/TRS/Get_Tasas_Tramite/'
        },
        Get_Tasas_Historial_Pagos: {
            method: 'GET',
            withcredentials: true,
            params: {
                nro_Pagina: '@nro_Pagina',
                tam_Pagina: '@tam_Pagina',
                texto: '@texto'
            },
            url: portal.getUrlServer() + 'api/TRS/Get_Tasas_Historial_Pagos/'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/trs/trs-service.js